import { combineReducers } from "redux";
import reader from "./reader";
import studentReader from "./studentReader";
import loaders from "./loaders";
import modals from "./modals";
import templates from "./templates";
import classTabs from "./classTabs";
import student from "../entities/student";
export default combineReducers({
  reader,
  studentReader,
  templates,
  modals,
  loaders,
  tabs: classTabs,
  student,
});
